(function () {
  const BLOCK_HEADING_SELECTOR = '.article-faq__heading, .article-product-list__heading';

  function slugify(text) {
    return text
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function uniqueId(base, used) {
    let id = base || 'section';
    let suffix = 1;

    while (used.has(id)) {
      id = `${base}-${suffix}`;
      suffix += 1;
    }

    used.add(id);
    return id;
  }

  function getTocSelector(nav) {
    const levels = nav.dataset.tocHeadings === 'h2_h3' ? ['h2', 'h3'] : ['h2'];
    const contentSelectors = levels.map((tag) => `.post-content ${tag}`).join(', ');
    return `${contentSelectors}, ${BLOCK_HEADING_SELECTOR}`;
  }

  function queryHeadings(bodyMain, selector) {
    return [...bodyMain.querySelectorAll(selector)].filter((heading) => getHeadingLabel(heading));
  }

  function getHeadings(bodyMain, nav) {
    const headings = queryHeadings(bodyMain, getTocSelector(nav));

    if (headings.some((heading) => heading.tagName === 'H2')) {
      return { headings, primaryTag: 'H2' };
    }

    const h1Headings = queryHeadings(bodyMain, '.post-content h1');
    if (h1Headings.length) {
      return { headings: h1Headings, primaryTag: 'H1' };
    }

    const h3Headings = queryHeadings(bodyMain, '.post-content h3');
    return { headings: h3Headings, primaryTag: 'H3' };
  }

  function getHeadingLabel(heading) {
    const link = heading.querySelector('a');
    return (link ? link.textContent : heading.textContent).trim();
  }

  function getScrollOffset() {
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    );
    return (Number.isFinite(headerHeight) ? headerHeight : 80) + 24;
  }

  function scrollToHeading(heading) {
    const offset = getScrollOffset();
    const top = window.scrollY + heading.getBoundingClientRect().top - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function initToc(nav) {
    const sectionId = nav.dataset.articleToc;
    const bodyMain = document.querySelector(`#article-body-${sectionId} .article-body__main`);
    if (!bodyMain) return;

    const { headings, primaryTag } = getHeadings(bodyMain, nav);

    if (!headings.length) return;

    const list = nav.querySelector('.article-toc__list');
    const usedIds = new Set();
    let primaryIndex = 0;

    headings.forEach((heading) => {
      const isPrimary = heading.tagName === primaryTag;
      if (isPrimary) primaryIndex += 1;

      const label = getHeadingLabel(heading);
      const baseId = slugify(label);
      heading.id = uniqueId(baseId, usedIds);

      const item = document.createElement('li');
      item.className = isPrimary
        ? 'article-toc__item article-toc__item--h2'
        : 'article-toc__item article-toc__item--h3';

      const link = document.createElement('a');
      link.className = 'article-toc__link body-medium-m';
      link.href = `#${heading.id}`;

      if (isPrimary) {
        const number = document.createElement('span');
        number.className = 'article-toc__number';
        number.textContent = `${primaryIndex}.`;
        link.append(number, document.createTextNode(` ${label}`));
      } else {
        link.textContent = label;
      }

      link.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToHeading(heading);
        history.replaceState(null, '', `#${heading.id}`);
      });

      item.append(link);
      list.append(item);
    });

    nav.hidden = false;
  }

  document.querySelectorAll('[data-article-toc]').forEach(initToc);
})();
